import { render, staticRenderFns } from "./PagamentosSolicitadosTabelaDash.vue?vue&type=template&id=3bbf5cde&lang=html&"
import script from "./PagamentosSolicitadosTabelaDash.vue?vue&type=script&lang=js&"
export * from "./PagamentosSolicitadosTabelaDash.vue?vue&type=script&lang=js&"
import style0 from "./PagamentosSolicitadosTabelaDash.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/PagamentosSolicitadosTabelaDash.vue
// module id = 1245
// module chunks = 28